import clsx from "clsx";
import React, { FC, useEffect, useState } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { usePageFullPath } from "../../../../hooks/use-page-full-path";
import { Cta } from "../../../buttons/cta";

export interface CtaHeaderMenuItemProps extends Queries.CtaDataFragment {
  className?: string;
  id: string;
}

export const CtaHeaderMenuItem: FC<CtaHeaderMenuItemProps> = ({ className, ...ctaProps }) => {
  const { expandedItemId, setItemPanelExpanded, setExpandedItemId } = useHeaderMenu();
  const { id } = ctaProps;
  const fullPageLinkPath = usePageFullPath(ctaProps.pageLink?.id);

  // I'm using a state + effect to avoid rehydration errors due to missing window
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const isExpandedItem = expandedItemId === id;
      const isCurrentPage =
        !expandedItemId && !!window.location.pathname.match(new RegExp(`^${fullPageLinkPath}`));
      setIsActive(isExpandedItem || isCurrentPage);
    }
  }, [expandedItemId, id, fullPageLinkPath]);

  return (
    <Cta
      {...ctaProps}
      onClick={() => {
        setExpandedItemId(null);
        setItemPanelExpanded(false);
      }}
      className={clsx(
        "hover:underline text-light lg:text-dark",
        isActive && "underline",
        className
      )}
    >
      {ctaProps.label}
    </Cta>
  );
};
